import React from 'react';
import { useEffectOnceOnMount } from '@wix/da-hooks/pkg/useEffectOnceOnMount';
import { PapiCorePackage } from '@wix/da-papi-types';

interface UseOpenPopupOnIdParamProps {
  monthlyPackage: PapiCorePackage;
  yearlyPackage: PapiCorePackage;
  setSelectedPackage: React.Dispatch<React.SetStateAction<number[]>>;
  setIsPopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useOpenCPPopupOnIdParam({
  monthlyPackage,
  yearlyPackage,
  setSelectedPackage,
  setIsPopupOpen,
}: UseOpenPopupOnIdParamProps) {
  useEffectOnceOnMount(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const subproductIdFromUrl = parseInt(urlParams.get('id') || '', 10);

    if (!subproductIdFromUrl) {
      return;
    }

    if (
      monthlyPackage.subproductId !== subproductIdFromUrl &&
      yearlyPackage.subproductId !== subproductIdFromUrl
    ) {
      return;
    }

    setSelectedPackage([
      monthlyPackage.subproductId,
      yearlyPackage.subproductId,
    ]);
    setIsPopupOpen(true);

    // Remove 'id' from the URL
    urlParams.delete('id');
    const newUrl = urlParams.toString()
      ? `${window.location.pathname}?${urlParams.toString()}`
      : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
  });
}

export default useOpenCPPopupOnIdParam;
